
import { defineComponent } from 'vue'
import { formatCurrency } from '@/libs/formatCurrency'
import Card from '@/components/Card.vue'
import DescriptionList from '@/components/DescriptionList.vue'
import DifferentLenderButton from '@/components/DifferentLenderButton.vue'

export default defineComponent({
  components: {
    Card,
    DescriptionList,
    DifferentLenderButton
  },

  props: {
    loanAmount: {
      required: true,
      type: Object
    },

    baseInterestRate: {
      required: true,
      type: [String, Number]
    }
  },

  emits: ['differentLender'],

  setup () {
    return {
      formatCurrency
    }
  }
})
